module.exports = __webpack_public_path__ + "img/solid-lock-alt-f30d.f0a5f40c.svg";